import RolesPermissions from '../components/RolesPermissions'

export default RolesPermissions;